/**
 * Formatta secondi di recupero per la UI (es. 105 → 1'45").
 * Sotto il minuto: solo secondi con secondi tra virgolette (es. 45").
 */
export function formatRecoveryDisplaySeconds(totalSeconds) {
  const n = parseInt(totalSeconds, 10);
  if (Number.isNaN(n) || n < 0) return '-';
  if (n === 0) return '0"';
  const m = Math.floor(n / 60);
  const s = n % 60;
  if (m === 0) return `${s}"`;
  return `${m}'${String(s).padStart(2, '0')}"`;
}
